import styled from '@emotion/styled';
import { alpha } from '@mui/material/styles';
import { Grid, TableHeaderRow, VirtualTable } from '@devexpress/dx-react-grid-material-ui';

export const GridRoot = styled(Grid.Root)`
  width: 100%;
  height: 100%;
`;

export const VirtualTabledRow = styled(VirtualTable.Row)`
  transition: background-color 160ms ease, box-shadow 160ms ease;

  &:nth-of-type(even) {
    background-color: ${({ theme }) => theme.customTokens.surfaces.dataGridRowEven};
  }

  :hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
    box-shadow: inset 3px 0 0 ${({ theme }) => theme.palette.primary.main};
  }
`;

export const TableHeaderRowRow = styled(TableHeaderRow.Row)`
  background: ${({ theme }) => alpha(theme.palette.background.paper, 0.86)};

  /* Keep filler/stub header area visually identical to column header cells. */
  .MuiTableCell-root,
  .TableStubCell-stubCell {
    background-color: ${({ theme }) => alpha(theme.palette.background.paper, 0.86)};
  }
`;
